import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { Facebook, Instagram, Youtube, Telegram } from '@sgcmpteltd/uikit-react';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const SOCIAL_MEDIA_LIST_LAYOUT_NORMAL = 'normal';
const SOCIAL_MEDIA_LIST_LAYOUT_COMPACT = 'compact';
const SOCIAL_MEDIA_ICON_SIZE = 23;

const socialMediaConfigMap = {
    facebook: {
        icon: Facebook,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Facebook icon',
        url: 'https://www.facebook.com/sgcarmart',
    },
    instagram: {
        icon: Instagram,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Instagram icon',
        url: 'https://www.instagram.com/sgcarmart/?hl=en',
    },
    youtube: {
        icon: Youtube,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Youtube icon',
        url: 'https://www.youtube.com/user/SGCMVids',
    },
    telegram: {
        icon: Telegram,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Telegram icon',
        url: 'https://t.me/sgcmcommunity',
    },
};
const layoutConfigMap = {
    [SOCIAL_MEDIA_LIST_LAYOUT_NORMAL]: {
        className: 'isNormal',
    },
    [SOCIAL_MEDIA_LIST_LAYOUT_COMPACT]: {
        className: 'isCompact',
    },
};

var css_248z = ".SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_t3oik_1 {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_t3oik_1.SGCM_UIKIT_NEXT_SocialMediaList_isNormal_t3oik_7 {\n  column-gap: 20px;\n}\n.SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_t3oik_1.SGCM_UIKIT_NEXT_SocialMediaList_isCompact_t3oik_10 {\n  column-gap: 17px;\n}\n\n.SGCM_UIKIT_NEXT_SocialMediaList_linkSocialMedia_t3oik_14 {\n  display: block;\n  font-size: 0;\n}\n\n.SGCM_UIKIT_NEXT_SocialMediaList_iconSocialMedia_t3oik_19 {\n  color: gray;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixVQUFVO0VBQ1YsU0FBUztFQUNULHFCQUFxQjtBQUN2QjtBQUNBO0VBQ0UsZ0JBQWdCO0FBQ2xCO0FBQ0E7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QsWUFBWTtBQUNkOztBQUVBO0VBQ0UsV0FBVztBQUNiIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5saXN0U29jaWFsTWVkaWEge1xuICBkaXNwbGF5OiBmbGV4O1xuICBwYWRkaW5nOiAwO1xuICBtYXJnaW46IDA7XG4gIGxpc3Qtc3R5bGUtdHlwZTogbm9uZTtcbn1cbi5saXN0U29jaWFsTWVkaWEuaXNOb3JtYWwge1xuICBjb2x1bW4tZ2FwOiAyMHB4O1xufVxuLmxpc3RTb2NpYWxNZWRpYS5pc0NvbXBhY3Qge1xuICBjb2x1bW4tZ2FwOiAxN3B4O1xufVxuXG4ubGlua1NvY2lhbE1lZGlhIHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtc2l6ZTogMDtcbn1cblxuLmljb25Tb2NpYWxNZWRpYSB7XG4gIGNvbG9yOiBncmF5O1xufSJdfQ== */";
var styles = {"listSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_t3oik_1","isNormal":"SGCM_UIKIT_NEXT_SocialMediaList_isNormal_t3oik_7","isCompact":"SGCM_UIKIT_NEXT_SocialMediaList_isCompact_t3oik_10","linkSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_linkSocialMedia_t3oik_14","iconSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_iconSocialMedia_t3oik_19"};
styleInject(css_248z);

const SocialMediaList = ({ layout }) => (jsx("ul", { className: cx(styles.listSocialMedia, styles[layoutConfigMap[layout].className]), children: Object.entries(socialMediaConfigMap)
        .map(([socialMedia, { url, icon: SocialMediaIcon, iconSize, label, },]) => (jsx("li", { children: jsx("a", { "aria-label": label, className: styles.linkSocialMedia, href: url, rel: "noreferrer noopener", target: "_blank", children: jsx(SocialMediaIcon, { className: styles.iconSocialMedia, size: iconSize }) }) }, socialMedia))) }));

export { SocialMediaList as S, SOCIAL_MEDIA_LIST_LAYOUT_COMPACT as a, SOCIAL_MEDIA_LIST_LAYOUT_NORMAL as b };
//# sourceMappingURL=component-CQE4GL5P.js.map
